import React from "react";

// import { Container } from './styles';

const Configurations = () => <div>Configurations</div>;

export default Configurations;
